import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "35f97d30-3547-47c1-890f-8d9a34e960fd",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Overall level:",
    suffixText: "dB SPL",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 86,
};
